import React from 'react';
import MenuSection from '../components/Home/MenuSection';

const Menu = () => {
    return (
        <main>
            <MenuSection />
        </main>
    );
};

export default Menu;